import Vue from 'vue'
import router from './router/index'
import ElementUI from 'element-ui';
import moment from "moment";
import PickerOptions from "@/config/PickerOptions";
import ValidateUtil from '@/config/ValidateUtil'
import FunctionUtils from '@/config/FunctionUtils'
import {Post} from "@/config/ServiceUtils";
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
moment.locale('zh-cn');
Vue.use(ElementUI, { size: 'medium',loading:true});
Vue.prototype.$moment=moment;
Vue.prototype.$post=Post;
Vue.prototype.$pickeroptions=PickerOptions;
Vue.prototype.$validateUtil=ValidateUtil;
Vue.prototype.$functionUtils=FunctionUtils;
Vue.prototype.$uploadurl="https://image.service.jiantujianzhi.com/api/upload/image";
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')